var packageName = "@atlassian/switcher";
var packageVersion = "31.4.0";
export default {
  packageName: packageName,
  packageVersion: packageVersion
};